// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"automatic-numbering"},"nodeName":"g","children":[{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"fill":"currentColor","d":"M11.998 9.99805H12.002V10.002H11.998V9.99805Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11.998 20.998H12.002V21.002H11.998V20.998Z"},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M3 3H4C4.55228 3 5 3.4514 5 4.00368L5 10M5 10H3M5 10H7M17 3H18C18.5523 3 19 3.4514 19 4.00368V10M19 10H17M19 10H21M3 14H4C4.55228 14 5 14.4514 5 15.0037L5 21M5 21H3M5 21H7M17 14H20C20.5523 14 21 14.4477 21 15V16.5C21 17.0523 20.5523 17.5 20 17.5H18C17.4477 17.5 17 17.9477 17 18.5V21H21M11.998 9.99805H12.002V10.002H11.998V9.99805ZM11.998 20.998H12.002V21.002H11.998V20.998Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-automatic-numbering')
export default class AutomaticNumberingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'automatic-numbering',
    }
  }
}
